import clsx from "clsx";

type Props = {
  value: string | boolean | number;
  label?: string;
  selectedValue?: string | string[] | boolean | number | undefined;
  onChange?: (value: string | string[] | boolean | number | undefined) => void;
  isFirstElementInTheList?: boolean;
  isLastElementInTheList?: boolean;
  disabled?: boolean;
};

export function SelectableOptionButton({
  value,
  label,
  selectedValue,
  onChange = () => {},
  isFirstElementInTheList,
  isLastElementInTheList,
  disabled,
}: Props) {
  const onOptionPressed = () => {
    if (!disabled) {
      if (
        typeof selectedValue === "string" ||
        typeof selectedValue === "boolean" ||
        typeof selectedValue === "number" ||
        selectedValue === null
      ) {
        onChange(value);
      } else if (Array.isArray(selectedValue)) {
        if (selectedValue?.length === 0) {
          onChange([value as string]);
        } else if (selectedValue?.includes(value as string)) {
          onChange(selectedValue?.filter((item) => item !== value));
        } else {
          const newTab: string[] = [...selectedValue, value as string];
          onChange(newTab);
        }
      } else {
        onChange(value);
      }
    }
  };

  const isSelected = () => {
    if (
      typeof selectedValue === "string" ||
      typeof selectedValue === "boolean" ||
      typeof selectedValue === "number"
    ) {
      return selectedValue === value;
    }

    return selectedValue?.includes(value as string);
  };

  const buttonClass = clsx(
    "flex flex-1 w-full max-w-[150px] items-center justify-center py-3 border-2 border-secondaryMid",
    isSelected() ? "bg-secondary-500" : "bg-white",
    isFirstElementInTheList ? "rounded-l-md border-r-[1px]" : "",
    isLastElementInTheList ? "rounded-r-md border-l-[1px]" : "",
    !isFirstElementInTheList && !isLastElementInTheList && "border-x-[1px]",
    disabled && !isSelected() && "opacity-40"
  );

  return (
    <div onClick={onOptionPressed} className={buttonClass}>
      <span className="text-sm font-medium text-center text-black">
        {label ||
          (typeof value === "number" ? (value as unknown as string) : value)}
      </span>
    </div>
  );
}

export default SelectableOptionButton;
